export const SITE_LEAD_REFERRAL_LIST = 'SITE_LEAD_REFERRAL_LIST';
export const SITE_LEAD_REFERRAL_SPOC_LIST = 'SITE_LEAD_REFERRAL_SPOC_LIST';
export const SITE_LEAD_REFERRAL_REJECT_REASONS = 'SITE_LEAD_REFERRAL_REJECT_REASONS';
export const SITE_LEAD_REFERRAL_STATUS_HISTORY = 'SITE_LEAD_REFERRAL_STATUS_HISTORY';
